import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';
import { SvgIconModule } from '../svg-icon';
import { InputFormFieldComponent } from './input-form-field.component';


@NgModule({
    declarations: [
        InputFormFieldComponent,
    ],
    exports: [
        InputFormFieldComponent,

    ],
    imports: [
        CommonModule,
        SvgIconModule,
        ClipboardModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class InputFormFieldModule { }
